export const PaymentMethodV2 = {
  CARD: 'card',
  PAYPAL: 'paypal',
  APPLEPAY: 'applepay',
  GOOGLEPAY: 'googlepay',
} as const;

export const DEFAULT_PAYMENT_METHODS = [
  PaymentMethodV2.CARD,
  PaymentMethodV2.APPLEPAY,
  PaymentMethodV2.GOOGLEPAY,
];

export type PaymentMethodV2Type =
  (typeof PaymentMethodV2)[keyof typeof PaymentMethodV2];

export const CardTypes = {
  CREDIT: 'credit',
  DEBIT: 'debit',
  PREPAID: 'prepaid',
};

export type CardType = (typeof CardTypes)[keyof typeof CardTypes];

export type PaymentMethodOption = {
  id: PaymentMethodV2Type;
  label: string;
  iconSrc: string;
  selectedIconSrc?: string;
  disabled?: boolean;
  visible?: boolean;
};
